export type EntitlementsNavigationState = {dataset?: boolean} | null;

export const ALL_ENTITLEMENTS_PATH = '/entitlements';
export const DATASET_ENTITLEMENTS_PATH = '/entitlements/dataset-entitlements';

export const DATASET_NAVIGATION_STATE: EntitlementsNavigationState = {dataset: true};

export const isDatasetNavigationState = (state: unknown): boolean => (
    Boolean((state as EntitlementsNavigationState)?.dataset)
);

export const getEntitlementsReturnPath = (state: unknown): string => (
    isDatasetNavigationState(state) ? DATASET_ENTITLEMENTS_PATH : ALL_ENTITLEMENTS_PATH
);
